import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Injectable, EventEmitter} from '@angular/core';
import {TokenStorageService} from './token-storage.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';

const API = `${environment.api}/api/aides`;
@Injectable({
  providedIn: 'root'
})
export class AidesService {
  constructor(private http: HttpClient, private tokenStorage: TokenStorageService) { }

  getAides(): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Accept': '*/*'
      })
    };    
    return this.http.get(API, httpOptions);
  }
}
